export const allowlistAddresses = [
  
["0xbf263dc8676850ad98f20a47c0fcbcc2bed1da89",1],
["0x092a32bac18a83e394f679c3c9c02e5f9d6f5f14",1],
["0xdcea2a0baef09252c30ba97d7f309f5ca4c2af46",1],
["0xb2b2b940e3e8cdf2e9f9ebb8dbecb28fa3d473da",1],
["0x0e15b9ddfcfacbb96f2b812e13cb9112ac73618b",1],
["0x9f56bff4459a58488d76df9e42a1c8fe48046f7d",1],
["0x01752ea19fd116695a1af18895fb75c5a99ee4e0",1],
["0x1a3326bf12589ee53b3f796c9d376ea3df60d459",1],
["0xb7d994657d400d434e84b11d02c935be69957657",1],
["0xf8be90c1d610a3a1a8f7c6e56e00d2529ed1f9c0",1],
["0x62d35af3365f76b883bc54d05ac1fdb6b5f6d694",1],
["0x9f3e593474fda86dd892e57b8646f23f0f80ad09",1],
["0x22ec717a36833ef61fe79e21412bddf4e143ee52",1],
["0xedae9ec3e28352e74d1b519be088a7b59c891459",1],
["0xdba538633bf52b0cae66c42991fc94c4fe6cbeed",1],
["0x2c19a07573c404bfd18a89ec6779029f4c75f628",1],
["0x347a0ce4a345f442b1ef9e46bca76407cd3b8815",1],
["0x674bcf5edf37027cefa860fa8beb09f1f7edc6c6",1],
["0xf929ac599c54ab2320fbefcbbefba27dfe558607",1],
["0x2f617fa1c80bdeb85fc01c8dddd2fefd5a13a960",1],
["0x3fe0c03461f1a74b7a9dd670ac077db1c33f5b72",1],
["0x3243855e72f0bc21db47838e5607bc1ea23fb040",1],
["0xa96f20d8afc0794ba710aa1baa5411070ca6c061",1],
["0x56f7b803f3880d3f2146d8d547eb1c35032b8986",1],
["0x24cf15e275ccce3f29e24eedc27f0f2b23932dc0",1],
["0xa1a81412ae054e1f9c82586bbf2fe6aa39d256e4",1],
["0xb16b5bb24c9f48e8f9fc67f3ce8f7b7bee37f471",1],
["0x826d434d6fb50a988a7823adc16db3fd11fa29e9",1],
["0x5bab2a78c18aa2bdcf6b045ab15850cf21e0fd20",1],
["0xc9f6e34a9ad2e75ed4373f24e2651139c484b2c6",1],
["0xa01db1dd39f79a239038523d0fb51ddd1580139f",1],
["0x12c1f145107f53c7122cbf8ac372f9d61aef84eb",1],
["0xeb7a63737f75cd9b08829b57e7ea52803a221cf3",1],
["0xc0dc468bdd2126acf8d72dc6eb77949465784edb",1],
["0x8422075cf6daf10316ab867ce6b4db3d47d0458b",1],
["0x6506363e6b829d46760eb21762d972697e522058",1],
["0xeffa0b6b2ed1a91c14c281f23eabc4e2d7ff6fcf",1],
["0x5c3d97f9a3b7938ca043b3a671b4b05291a94823",1],
["0xc3f2f7d08ae59e0f6d22bd1c1ee7cd2f11cd21e4",1],
["0xeec66737e685278e6a2c495a6fe4679a14c68f35",1],
["0x0bc7fd075906c3a14428f9745743b5945d556896",1],
["0xdd11a8a06c16fa9292c0fb80cc7964c12d467c3f",1],
["0x3f3b1a82bdf41e7fbaf7ab1d4da42d1b235b14e6",1],
["0x51c9631896950a6fd0b03a709614fb75d891b3fa",1],
["0x48147b2c543a0eea58da03f54a9da3aa828b1584",1],
["0xf7f1c81f934278e8a20232ac6de3da238f26566f",1],
["0x45de1c3b41596224c51c66fc286aa5b363511dcb",1],
["0x95debaeb0c9eafe11fa5c7c96ab64dd4e436d769",1],
["0x1b66c6c91b7cf8015a354b01d6411a87161c1215",1],
["0xa0d8ddc7ec2249c6df227db8e6da21b6efee7f58",1],
["0xa18d39c37a6e78b91b1f36fc7d6ed91fcdb597e3",1],
["0x6909fe2c20fea0e84077e2c26709a42fd482fab2",1],
["0xc1124f513e1ef19b0ae344808a188c87fb3fc0f9",1],
["0xeadc8f8dd75c95c7b92db6d1c7129dd8631b5ea2",1],
["0xca30ba08dfecb451ce64bc765df1749185106bbf",1],
["0x3e1dc89ab1e3bb8a64bb0f65b65b404f1bf708c3",1],
["0x86eb8be678274ba4c47af17fa8511c3f9c631bbc",1],
["0x7d76dfa754d2b0bea24801ace10fc343c01be0a1",1],
["0x493da0cde8cbe456d096d296b88550a703939354",1],
["0x6d92de957d5a4cb0bda556da42962e788ae34557",1],
["0xbee7c22a4fcb8d9d6d24d6ed8b51457265526711",1],
["0xac75248edcd608878324c6894427977f8ef8599d",1],
["0xb5c40b3b119f091e97e3ecff68ce0763111a010b",1],
["0x45015fd0f2fa60df12afaf6370b62a7e7f150b47",1],
["0xf15b2d971b9b320d931b5264df47af3b4db82981",1],
["0x9e0696f09bb1e14c8d062e9c44ce36138f870d20",1],
["0x0931817f30842f4b67608cb6d2e623d502d6ab14",1],
["0x85e7fa0f1dfc325b3e496f25f2f0dc17998829f0",1],
["0x77ae1bcaed594a687b0a2a03a594a7308ed24173",1],
["0xece1d1ca2ccf6f877ca3e07a1f69a6e234f8784e",1],
["0xc2153b4118399c0ad331ad2c1d2d34bc48ea6048",1],
["0x09d3d71db36c0395e1d7f514e728f123357b03f2",1],
["0xb686f2d1de4b85abccbea51c7e95244572ad3c1c",1],
["0xdc9648bbd4fc4478feb7a81da25b516e285e5f6a",1],
["0x57628e17ef09dded2a7def205ab0120eb82b0dc5",1],
["0x005f9b4f14b994d69737f42176db734d0ad7053a",1],
["0x80a711d2598d5c22704aab78977663a86432638a",1],
["0x1a953bc7e8668b031d3dfc351cc3052aa264bd10",1],
["0x2a2f3d9a777038ce331ceeec14472cc6a37ccd62",1],
["0x10c9a886f545ba951edf64bee68d0cb7ef1cbffe",1],
["0x87481851f2cacfff8763f49bff57e7afe3ab87dc",1],
["0xe5fea09f8d0506ec709767b91533f736d63fb735",1],
["0xf511cfab8f2dbedeed91afa8a3fc6246c18d4ee4",1],
["0x2f73a899a0663b898de36c8c98992c73180f99d1",1],
["0x5e196564f2fcb21f695cc30fff78110ba4d2fdc4",1],
["0xdb77d3a9bf13f0b4886e868833bd8ca475ceeb9d",1],
["0xf2466d553b1d0cdf6ede3e8c2d3652e7338d3c70",1],
["0x0c7d841966696af4d1aff9a56424ab938626a443",1],
["0x16c0be20bb68a5930c7176f2f42ca82346b3246f",1],
["0xb8f3aa1b63b9c1452e2b7d72f8b0facade9e21da",1],
["0x00687b375430cb84a70b5c5e1adba641aef5d1f9",1],
["0x6112b496e43a05e61797743a45640df13efcf053",1],
["0x75c4d7544dc881596e3679345a7e915f62171dea",1],
["0x41debb4704c681b403ba3b0f8e78e3fe2f29bcca",1],
["0x756cf9df2d490c192243f047f808864c2369b825",1],
["0xc5e97dd71bff9102d3ee9781de07c8cde8391b18",1],
["0x794dbbe0a0ede6123cf22f3954ec49868c36c787",1],
["0x6d6191789d19332a89d8ddf311e6b0d278c9b0b1",1],
["0x07109aca84117902f428a90a80f071f71b270bb0",1],
["0xd24db0bfb387b0ed05f757e5f3b9ca1c59a82605",1],
["0x8fdedc0320a95c5a16e6cbdfa6700e82e80f6bdb",1],
["0x0ffb9b96d5a17cefd82b9309f1be5baceca311e0",1],
["0x291f5cc17d317bac617c1beaab73a0985683e815",1],
["0x69e9ec83cba73744fa44f4183e200e038320f4dc",1],
["0x612ca623e264782e3eae3e6efd589c2ff5a2b51c",1],
["0x6a1a6090ce9c522796f632c0a5dbebdc11e8eaef",1],
["0xba522a7ee4d0d38daa93734bf4daf8fd4c998c95",1],
["0xffe7f99312462fd85c0658b36e76c122e830a197",1],
["0xa909427988bb1ea4924b522eddebb9b6fb29a2f1",1],
["0xb990378362f9e15b3bfa05206cca8f7145ca703c",1],
["0xc934544944145535428352f14ba0be654b6cdd19",1],
["0x7e45c617350395ba24210c3b0f926f9973177b9f",1],
["0xe7d02aeca52f4000e88c373dc4ef1b022a2884c4",1],
["0x37d32679ce9245a3f67d4830cbb3453e85e705d3",1],
["0x0aee9fe13a9fc369e4af5edf31054273c88bc6ac",1],
["0xa17cc03654e43576fd890c3aeeb3670fb70dd540",1],
["0xb8c2e9fad29e4bbda3832bf8d3300727bc22a70d",1],
["0xf4796c3a78080dad8b3f1fcb39f097fe46b7bc0f",1],
["0xc7d44ca605ed597517ce47b6589cf6b0bd0e0252",1],
["0x4e2fdf615c83abee1be2464415416a8011deab59",1],
["0xe6fdb884bf7c69e31198dee9123f9e225afb57ae",1],
["0x24aae0a135985dc8ae6b8bac64051af645c2b3f9",1],
["0x65f5f7086d5f5658c0e3e81c53a1b01f1bccb3ec",1],
["0xcb37afe0ede69d77f9fd21c66a6fc18c94f12654",1],
["0xdb94454a0f213280321053cabd8a7848255bcbae",1],
["0x58608a7c9dac7b22da978a8c0a1c49802e822a70",1],
["0xa33b2df047886c5282ba8f7f2b49d2af3c8ee699",1],
["0x3a855960ced4f8b86f2644411dbacc5c973fc583",1],
["0xc78eeab7991ad02963fb1997f7aba9eb9d2027b5",1],
["0x87369e67068197d9a164884c4541bd1503ccfb8f",1],
["0xa62ef7ab9f3fd15bccd32c9fc6d2321f5a46ec0a",1],
["0x03c24d6910e612ca0c2933b798e26f09223ec13f",1],
["0x740ee70dc977b00dc9613e2799aedb775432b09b",1],
["0x198e19c0821563d1dfe13eec92550d99732bb354",1],
["0x687031aa5bdf89437e5b96e8380847471d5f2db1",1],
["0x55cf7856c7fd1cb488aacc7adbe241db6208e2f0",1],
["0xd6c8422839b7965dade45349f6bcea6b2963b480",1],
["0x1c7f1b7650d505a1a10d25b05d0f7b9cbd41c5f7",1],
["0x1112603845e343632a4fa185e1a37e0561065ae3",1],
["0x8e6e8f9f6c388332c321a8f4ae4e6242f084eb22",1],
["0x1f5066f3a87c117075f57eb3e9839f3999977fdd",1],
["0x8b885aea8d39a827f1ef6576a98b0ac3bbe3848e",1],
["0xcc24f1cf1ae36c8c6032b7914cd861230cba01b4",1],
["0xa0eab382c09b38db4c21a0dbfa9282ff955acd52",1],
["0xe306e12cfb846231222ee2372b810eb3f0a16c3c",1],
["0xe763287cf9034eb7e262c7abd27afc8c89116cd9",1],
["0xdeb3f6f80e1f9fc698990171a48578ecd2e42aef",1],
["0x7a23883b26973eb32ae3ca6ccb29513421649a5e",1],
["0xfd487911196048348e13a5933e25a8dfa1c64995",1],
["0x7d3bcd42c6a7995b509c75fcb20fe0891b0e26dc",1],
["0x3bd99cb7265e946feb1fc29b8dba4334d33f8794",1],
["0x8feeb7be0384643ad69dd097a1990b36a721c012",1],
["0xef3414015e61e834b27d0ae177261d98fe11905b",1],
["0xa1a45a2b5fcdcdc590f5203d194e563ae6742e32",1],
["0x21b5ad7ea02d44dd1e2ce38487da8781b84fd13a",1],
["0x8d1181285dd480af581e9e34b3677a66d6d69343",1],
["0x48b4e4a5f3f9b8ab6ff66ba31b30909ab97a7cbc",1],
["0x82e1e9666edac4eb98850ce2ef2cf9bfedf2183d",1],
["0xe51484e17a214aad2e52697554e81f04d21ee88e",1],
["0xcc1f01220b9d9a2bcabb87da9cbc75e2b8a06b8b",1],
["0x91c8fc23ff40b35c5c42efee401b9d04a90e23e9",1],
["0x88897bc45dd540413fe5bd1bfd9e04125af3ecc3",1],
["0x46ee5d9395b6e74695d3a11036e6708b530dc07d",1],
["0x81d3d728dabfc2c939a45addc2642406fc9dd8c6",1],
["0x9ad5f1545c1e25d3045c5f991fe40ef3d0ed069f",1],
["0x6313fdbc70088df6474f00aec0ea38413351e32b",1],
["0x2ec7c76f5b63962da5ce5366d611b2c79e4cb8cf",1],
["0x43c9a7e362c6ad43896e962cec9a3096302b154e",1],
["0x23b3e34f9a16644513890b3dd4f3694e5cff2861",1],
["0x2bd8afa9bdfd2899326b833507bd4dd0bfd846df",1],
["0xb577575a51927c83c9a30087dac9329b5d1c4571",1],
["0x4f6eca606167a45acd1968d9a4291b033855593f",1],
["0x6d5618388dc917134abbdcad7ae4071af9cb5a7d",1],
["0x3d663a4f09a00541ee7bb5094c8f56c7fa91a6e8",1],
["0xf308cc36bd85f135b5e65c8b8ede781b1cbed7bc",1],
["0x93a9426951e26f019e61dff6d222648b9d12a8f4",1],
["0xbe9e7f4eca05a83fd210c59db76be779e8003c68",1],
["0xf47d208056dbceb153084fb93926df96843f5b16",1],
["0x231ac6d364d6160a1fa901c255c2169c9a8bde73",1],
["0xd7f316a35be6ab7de00129161ac47eeefddc933d",1],
["0x0d1de6507595f78bfb86fa1b3288e6fb848b7989",1],
["0x85e995e103571033167145231ed6deef80f9ef9d",1],
["0xed8501a2d9e65ecdac99b63b82c9b168fadacca4",1],
["0x1ff8d935c9887f69bb163fd68d3a614379cccc27",1],
["0xd1a89c5d59815a1e5c531fa248d21165b0a24a5c",1],
["0x0194fc6d3a72d5bc37939f5fb53e220fc56f5cf6",1],
["0xc82934238d95e46722dcbcfc07bbc1880bdfd534",1],
["0x145ba000c10d761527dbcc674c902011f935687c",1],
["0x32f2a7a720e7d1f8a4044ee358ae56fe4ac3e756",1],
["0x2ccd4284945dac4a81f53e3521f42f21dcf8fd0e",1],
["0x004fb342f4b36e504f667a4fe6932e0a1e20e529",1],
["0xbab1a10d74da9943b593c3eadf95cd41b968a991",1],
["0x3e4e10718764b167db326859f552cd11cd873d72",1],
["0xb5d7cfe079b6a192a072b390fe5d0cf99c5e54d2",1],
["0x89fc135b9edd480d4945afb36f67b609e73e1b90",1],
["0x9de62c4476f07003547edf75330bf30303cad90f",1],
["0xd0d5250a553d07f6622b19b04929f64e7876db93",1],
["0x5772bfd0ee58171712be1ceebdd1126b5bb9ea93",1],
["0x4b0e401bade7878a62d6eb4996f3539c4a001037",1],
["0xcc24001414caf0c985e35167a2561994203af7a9",1],
["0x03eeba1287dbbc6e5a10e3c916976a27ad00fe29",1],
["0xec6001d3a7feb39ff3eb59b2f12372eca1c9ebd5",1],
["0x60fea19ec1e9e210fbf1bc5e5f19f4fdfdaf8281",1],
["0x51d8b206a7fa809c414e49596c060b397b9d5ad2",1],
["0x972f49020130be2fee1ba7b2db2b2b571f131765",1],
["0xb3936e5b1d562d0bd6e4028f323740278e67a41b",1],
["0xf533c31ff773589fdc4dfa562990459d711f116e",1],
["0xfbc41168272707768a85706ea09feaa64680e712",1],
["0x2f232baab931f0c1243fc848c290e500ac7e7c0e",2],
["0x1c3509ebb0d61a1efc7d7cca479e9aa973f5a2f0",1],
["0x89f360494251aa0f37700a4e9d935998d352a9f7",1],
  
]